export const SERVICES_URLS = {
	API: 'api/',
	AUTH: 'auth/',
	SERVICES: {
		personal: 'personal/',
		registro_horario: 'registro_horario/',
		registro_horario_historial: 'registro_horario_historial/',
		personal_registro_horario: 'personal_registro_horario/',
		get_horario: 'get_horario/',
		get_personal_horario: 'get_personal_horario/',
		get_register_All:'get_register_All/',
		get_personal_filter:'get_personal_filter/',
		get_personal_by_id:'get_personal_by_id',
		get_load_size:'get_load_size',
		import_excel:'import_excel',
		import_data_excel:'import_data_excel',
		upload_file:'upload_file/',
		download_file:'download_file/',
		download_registro_horario_xls_file: 'download_registro_horario_xls_file/',
		download_registro_horario_rwn_file: 'download_registro_horario_rwn_file/',
		download_registro_horario_table_xls_file: 'download_registro_horario_table_xls_file/',
		change_status:'change_status/',
		user_save:'user_save/',
		users: 'usuarios/',
    get_encargados:'get_encargados/',
    get_cabecillas:'get_cabecillas/',
		get_user_data: 'get_user_data/',
		get_permissions: 'get_user_permissions/',
		labor_list: 'labor_list/',
		labor: 'labor/',
		download_labores_xls_file: 'download_labores_xls_file',
		download_labores_pdf_file: 'download_labores_pdf_file',
		complete_day: 'complete_day/',
		jornadas_pendientes: 'jornadas_pendientes/',
		jornadas_pendientes_cerrar: 'jornadas_pendientes/cerrar/',
		fichajes_sin_persona: 'fichajes_sin_persona/',
		fichajes_sin_persona_excel: 'fichajes_sin_persona/excel/',
		fichajes_a_revisar: 'fichajes_a_revisar/',
		fichajes_a_revisar_excel: 'fichajes_a_revisar/excel/',
	},
	EXPORT_PATH: 'export/',
	UPLOAD_IMAGE:'static/personal/',
	OPEN_MAP_URL: 'http://nominatim.openstreetmap.org/'
};



// WEBPACK FOOTER //
// /app/src/app/theme/services/resources/services.urls.ts